<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4>Diskusi Baru</h4>
        <div class="replyTo" v-if="replyTo">
          <label>Balas ke</label>
          <div class="replyToCnt">
            <div class="replyToAvatar hasPict">
              {{replyTo.user.name.substr(0, 1)}}
            </div>
            <h4>{{replyTo.user.name}}</h4>
            <p>{{replyTo.content}}</p>
          </div>
        </div>
        <div class="postContent">
          <div class="avatar hasPict">{{initial}}</div>
          <div class="post" contenteditable placeholder="Tulis sesuatu..."
            v-on:input="contentChanged"></div>
          <div class="postError" v-if="form.content.error">Mohon tulis sesuatu</div>
        </div>
        <div class="actions">
          <button class="btn primary" :class="{loading: loading}" v-on:click="post">
            <span>Kirim</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      form: {
        content: { model: '', error: null },
      },
      next: null,
      loading: false,
      initial: '',
      replyTo: null,
      groupId: 0,
    };
  },
  methods: {
    open(d, n) {
      this.groupId = d.groupId;
      this.replyTo = (d && d.replyTo) ? d.replyTo : null;
      this.form.content.model = '';
      this.form.content.error = null;
      this.loading = false;
      this.next = n;
      this.show = true;
      this.initial = localStorage.getItem('name').substr(0, 1);
    },
    contentChanged(e) {
      this.form.content.error = null;
      this.form.content.model = e.target.innerText;
    },
    post() {
      if (!this.form.content.model || this.form.content.model.trim() === '') {
        this.form.content.error = 'Mohon tulis sesuatu';
        return;
      }
      this.loading = true;
      const replyToId = this.replyTo ? this.replyTo.id : null;
      this.$http.post(this.$config.uri(`group/${this.groupId}/post`), {
        content: this.form.content.model,
        replyToId,
      }).then((r) => {
        this.close(true, r.data.data);
      });
    },
    close(b, result) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, result);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.5);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 60px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      max-width: none;
      width: 360px;
      @media (max-width: 680px) {
        width: auto;
        left: 10px; right: 10px;
        padding: 30px;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }

      .replyTo{
        padding-top: 10px;
        margin-right: 16px;
        margin-left: 78px;
        padding-bottom: 10px;
        label{
          font-weight: 600;
          font-size: 12px;
          margin-bottom: 8px;
          display: block;
        }
        .replyToCnt{
          position: relative;
          position: relative;
          border: #eee 1px solid;
          padding: 10px;
          padding-left: 56px;
          border-radius: 10px;

          border: none;
          border-bottom: #eee 1px solid;
          border-radius: 0;
          padding: 0;
          padding-bottom: 10px;
          padding-left: 48px;
          .replyToAvatar{
            width: 38px; height: 38px;
            background-color: #eee;
            border-radius: 50%;
            position: absolute;
            left: 10px; top: 10px;

            left: 0; top: 1px;

            display: flex;
            align-items: center;
            justify-content: center;
            &.hasPict{
              background-color: #fee66e;
              color: #000;
              font-weight: 800;
              font-size: 14px;
            }
          }
          h4{
            font-weight: 600;
            font-size: 14px;
            margin: 0;
          }
          p{
            margin: 0;
            font-size: 14px;
            color: #444;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 160px;
          }
        }
      }
      .postError{
        color: red;
        font-size: 12px;
        margin: 0 0 10px;
        border-top: red 1px solid;
        padding-top: 4px;
      }
      .postContent{
        position: relative;
        padding-left: 78px;
      }
      .avatar{
        width: 60px; height: 60px;
        border-radius: 50%;
        position: absolute;
        left: 0; top: 16px;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        &.hasPict{
          background-color: #fee66e;
          color: #000;
          font-weight: 800;
          font-size: 24px;
        }
      }
      .post{
        min-height: 120px;
        outline: 0;
        font-size: 17px;
        border: none;
        padding: 16px 0;
        &:empty::before {
          content: attr(placeholder);
          color: #999;
        }
      }
      .actions{
        text-align: right;
        // border-top: #eee 1px solid;
        padding: 10px 0 0;
        .btn{
          padding: 12px 30px;
          border-radius: 50px;
        }
      }
    }
  }
</style>
